import React, { Component } from 'react'
import LanguageItem from './LanguageItem';
import { word } from '../words.js';

export default class Language extends Component {

    itemClick(lang){
        this.props.onLanguageClick(lang)
    }

    render() {
        return (
            <div className="dialogBox">
                <div className={this.props.currentLang.direction==='rtl'?"popupTitle IRANSansMobileBoldFont":"popupTitle SFUIDisplayBoldFont"} style={{marginBottom:'20px'}}>{word[this.props.currentLang.tag]['chooseLanguage']}</div>
                {this.props.userLangList.map((item, i) => {
                    return <LanguageItem key={i} id={item.id} langItem={item} selected={item.languageId===this.props.currentLang.languageId?true:false} title={item.title} direction={this.props.currentLang.direction} onLangItemClick={this.itemClick.bind(this)} />
                })}
                {/* <LanguageItem langItem={null} selected={item.id===this.props.currentLang.languageId?true:false} title={item.name} direction={this.props.currentLang.direction} onClick={this.itemClick.bind(this)} /> */}
            </div>
        )
    }
}
